import { render, staticRenderFns } from "./smallTaskDetail.vue?vue&type=template&id=3db4ee5a&scoped=true&"
import script from "./smallTaskDetail.vue?vue&type=script&lang=js&"
export * from "./smallTaskDetail.vue?vue&type=script&lang=js&"
import style0 from "./smallTaskDetail.vue?vue&type=style&index=0&id=3db4ee5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db4ee5a",
  null
  
)

export default component.exports